// Get the current day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
let currentDay = new Date().getDay();

if (currentDay === 0) {
  // Show the popup on Sundays
  let popup = document.createElement("div");
  popup.id = "sunday-popup";

  // Create a container for the popup content
  let popupContent = document.createElement("div");
  popupContent.innerHTML = `
        <h2>Zondag Gesloten</h2>
        <h4>Beste bezoeker</h4>
        <p>Op zondag zijn wij altijd gesloten. Wij beschouwen de zondag vanuit onze christelijke geloofsovertuiging als rustdag waarop wij geen commerciële activiteiten doen. 
          Om die reden is het op zondag niet mogelijk om een bestelling te plaatsen. Graag zien wij u op andere dagen van de week terug.</p>
        <button onclick="closePopup()">Sluiten</button>
    `;

  // Add the content to the popup
  popup.appendChild(popupContent);
  document.body.appendChild(popup);

  // Disable all "Add to Cart" buttons and quick add buttons on Sunday
  let addToCartButtons = document.querySelectorAll(
    'button.overlay-tertiary, button.preorder-button, button[type="submit"], button.circle, ' +
      'a.circle.overlay-tertiary[data-quickshop], a.circle.overlay-tertiary[aria-label="Add to cart"], ' +
      "a.circle.plain.overlay-tertiary[data-quickshop], " +
      'a.circle.plain.overlay-tertiary[style*="--circle_size:55px"]'
  );

  addToCartButtons.forEach((button) => {
    if (button.tagName === "BUTTON") {
      button.disabled = true;
      button.style.backgroundColor = "#ccc"; // Change button appearance to show it's disabled
      button.innerText = "Vandaag gesloten"; // Change button text to indicate store closure
    } else if (button.tagName === "A") {
      button.style.pointerEvents = "none"; // Disable click events on anchor tags
      button.style.opacity = "0.5"; // Visual indication that it's disabled
      button.style.backgroundColor = "#ccc"; // Match the disabled button style
      // Remove the href to prevent navigation
      button.removeAttribute("href");
      // Add a title to show it's disabled on hover
      button.setAttribute("title", "Winkel is vandaag gesloten");
    }
  });

  // Function to close the popup
  function closePopup() {
    document.getElementById("sunday-popup").style.display = "none";
  }
}
